import script from "./ConfiguratorModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfiguratorModal.vue?vue&type=script&setup=true&lang=js"

import "./ConfiguratorModal.vue?vue&type=style&index=0&id=23762668&lang=scss&scoped=true"

import exportComponent from "/var/www/lueco/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23762668"]])

export default __exports__